// extracted by mini-css-extract-plugin
module.exports = {"content":"confirm-item-navigation_content__kGg3x","header":"confirm-item-navigation_header__XEMnU"};